import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const SettingsContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchSettings = useCallback(async () => {
        try {
            const response = await axios.get(`${API}/settings`);
            setSettings(response.data);
            
            // Update favicon if set
            if (response.data.favicon_url) {
                const faviconUrl = response.data.favicon_url.startsWith('http') 
                    ? response.data.favicon_url 
                    : `${process.env.REACT_APP_BACKEND_URL}${response.data.favicon_url}`;
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/x-icon';
                link.rel = 'shortcut icon';
                link.href = faviconUrl;
                document.getElementsByTagName('head')[0].appendChild(link);
            }
            
            // Update document title
            if (response.data.meta_title) {
                document.title = response.data.meta_title;
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    const refreshSettings = async () => {
        await fetchSettings();
    };

    return (
        <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};
